import React from 'react';
import PropTypes from 'prop-types';
import globals from '../../../globals/communityGlobals';
import PrivateNavLink from '../../../containers/common/PrivateNavLink/PrivateNavLinkContainer';

const styles = {
  selected: 'selected',
};
const locale = globals.getArea('header');
const featureAccesses = {
  dashboard: [globals.applicationFeatureAccesses.canAccessDashboard],
  dailyPlanning: [
    globals.applicationFeatureAccesses.canAccessCliniciansView,
    globals.applicationFeatureAccesses.canAllocateWork,
  ],
  visitActuals: [globals.applicationFeatureAccesses.canActualisePatientVisits],
  reports: [globals.applicationFeatureAccesses.canAccessReports],
  patients: [
    globals.applicationFeatureAccesses.canAddPatients,
    globals.applicationFeatureAccesses.canEditPatients,
    globals.applicationFeatureAccesses.canAddReferrals,
    globals.applicationFeatureAccesses.canEditReferrals,
    globals.applicationFeatureAccesses.canAddTreatments,
    globals.applicationFeatureAccesses.canEditTreatments,
  ],
  nonPatientActivities: [globals.applicationFeatureAccesses.canSetUpTeamMeetings],
  admin: [globals.applicationFeatureAccesses.canTriggerSync],
};
class NavBar extends React.Component {
  shouldComponentUpdate(nextProps) {
    return this.props.currentPathname !== nextProps.currentPathname;
  }
  isActive(match) {
    return () => this.props.currentPathname.indexOf(match) === 0;
  }
  render() {
    return (
      <div className="top-level-nav">
        <nav>
          <PrivateNavLink
            featureAccess={featureAccesses.dashboard}
            id="dashboard-header-navlink"
            to="/Dashboard"
            activeClassName={styles.selected}
            isActive={this.isActive('/Dashboard')}
          >
            {locale.getMsg('dashboard')}
          </PrivateNavLink>
          <PrivateNavLink
            featureAccess={featureAccesses.dailyPlanning}
            id="dailyplanning-header-navlink"
            to="/DailyPlanning"
            activeClassName={styles.selected}
            isActive={this.isActive('/DailyPlanning')}
          >
            {locale.getMsg('dailyPlanning')}
          </PrivateNavLink>
          <PrivateNavLink
            featureAccess={featureAccesses.visitActuals}
            id="visitactuals-header-navlink"
            to="/VisitActuals"
            activeClassName={styles.selected}
            isActive={this.isActive('/VisitActuals')}
          >
            {locale.getMsg('visitActuals')}
          </PrivateNavLink>
          <PrivateNavLink
            featureAccess={featureAccesses.reports}
            id="reports-header-navlink"
            to="/Reports"
            activeClassName={styles.selected}
            isActive={this.isActive('/Reports')}
          >
            {locale.getMsg('reports')}
          </PrivateNavLink>
          <PrivateNavLink
            featureAccess={featureAccesses.patients}
            id="patients-header-navlink"
            to="/Patients"
            activeClassName={styles.selected}
            isActive={this.isActive('/Patients')}
          >
            {locale.getMsg('patients')}
          </PrivateNavLink>
          <PrivateNavLink
            featureAccess={featureAccesses.nonPatientActivities}
            id="nonpatientactivities-header-navlink"
            to="/NonPatientActivities"
            activeClassName={styles.selected}
            isActive={this.isActive('/NonPatientActivities')}
          >
            {locale.getMsg('nonPatientActivities')}
          </PrivateNavLink>
          <PrivateNavLink
            featureAccess={featureAccesses.admin}
            id="admin-header-navlink"
            to="/Admin"
            activeClassName={styles.selected}
            isActive={this.isActive('/Admin')}
          >
            {locale.getMsg('admin')}
          </PrivateNavLink>
        </nav>
      </div>
    );
  }
}

NavBar.propTypes = {
  currentPathname: PropTypes.string.isRequired,
};

export default NavBar;
